import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";

/**
 * Search model for Account Payments
 */
@Injectable()
export class AccountPaymentSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "paymentId";
    }


    override isEntityLocalisable(): boolean {
        return false;
    }
}
